/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { NodeProps, Handle, Position } from "reactflow";
import { Box, Typography, Avatar } from "@mui/material";
import getIconForEntityType from "./entity-type-icons";
import { getColorForEntityType } from "./link-chart-helpers";

/**
 * Custom node component for the link chart graph
 */
const CustomNode: React.FC<NodeProps> = ({ data, selected }) => {
  const color = getColorForEntityType(data.entityTypeDescription || "");

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        id="target-top"
        style={{ opacity: 0 }}
      />
      <Handle
        type="target"
        position={Position.Left}
        id="target-left"
        style={{ opacity: 0 }}
      />
      <Handle
        type="target"
        position={Position.Right}
        id="target-right"
        style={{ opacity: 0 }}
      />
      <Handle
        type="target"
        position={Position.Bottom}
        id="target-bottom"
        style={{ opacity: 0 }}
      />

      <Box
        sx={{
          minWidth: 100,
          maxWidth: 220,
          backgroundColor: "white",
          border: selected ? `3px solid ${color}` : `2px solid ${color}`,
          borderRadius: 1.5,
          p: 1,
          boxShadow: selected
            ? "0 8px 24px rgba(0,0,0,0.3)"
            : "0 4px 12px rgba(0,0,0,0.15)",
          cursor: "grab",
          "&:active": {
            cursor: "grabbing",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Avatar
            sx={{
              width: 32,
              height: 32,
              backgroundColor: color,
              fontSize: "1rem",
            }}
          >
            {getIconForEntityType(data.entityTypeDescription || "")}
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                fontSize: "0.8125rem",
                wordBreak: "break-word",
                lineHeight: 1.2,
              }}
            >
              {data.label}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                display: "block",
                fontSize: "0.65rem",
                lineHeight: 1.2,
              }}
            >
              {data.entityTypeDescription}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Handle
        type="source"
        position={Position.Top}
        id="source-top"
        style={{ opacity: 0 }}
      />
      <Handle
        type="source"
        position={Position.Left}
        id="source-left"
        style={{ opacity: 0 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="source-right"
        style={{ opacity: 0 }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="source-bottom"
        style={{ opacity: 0 }}
      />
    </>
  );
};

export default CustomNode;
